import React from 'react';
import PropTypes from 'prop-types';

import '../../styles/irctcFaq.css';
import { IRCTC_FAQS } from '../../utils/RailsSEOConstants';

const IrctcFaq = ({ customClass }) => {
  return (
    <div className={`${customClass} faq`}>
      <ul>
        {IRCTC_FAQS.map((item) => {
          return (
            <li key={item.title}>
              <h5>{item.title}</h5>
              <p>{item.info}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

IrctcFaq.propTypes = {
  customClass: PropTypes.string
};

export default IrctcFaq;
